<template>
  <div class="questions">
    <h4 class="heading">Common Questions</h4>
    <div class="questions__layout">
      <div v-if="mq.mdPlus">
        <Question
          v-for="question in questions"
          :key="question.heading"
          :question="question"
        />
      </div>
      <Accordion
        v-for="question in questions"
        v-else
        :key="question.heading"
        show-arrow
        class="questions-accordion"
      >
        <template #header>
          <h4 class="question-heading">{{ question.heading }}</h4>
        </template>
        <template #body>
          <p class="question-text">{{ question.text }}</p>
        </template>
      </Accordion>
    </div>
  </div>
</template>

<script>
import Accordion from "@/components/Accordion.vue";
import Question from "@/components/Question";
export default {
  name: "Questions",
  components: {
    Question,
    Accordion,
  },
  inject: ["mq"],
  props: {
    questions: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.questions {
  padding: 20px 10px;

  @include respond-above(md) {
    padding: 20px;
  }
  .heading {
    color: $color-dark;
    font-family: $heading-font-family;
    font-size: 16px;
    margin: 0 0 20px 0;
    text-transform: uppercase;

    @include respond-above(md) {
      font-size: 30px;
    }
  }

  .questions__layout {
    @include respond-above(md) {
      column-count: 4;
    }
  }
}

::v-deep() {
  .questions-accordion.accordion--open {
    transition-timing-function: ease-out;
    background-color: $color-light;
    padding-bottom: 10px;
    margin-bottom: 20px;

    .accordion__header {
      transition-timing-function: ease-out;
      padding-top: 20px;
    }
  }
}

.questions-accordion {
  padding-left: 20px;
  padding-right: 20px;
  transition: all 0.3s;
  transition-timing-function: ease-in;

  ::v-deep() {
    .accordion__header {
      transition: padding-top 0.3s;
      transition-timing-function: ease-in;
      align-items: center;
      font-family: $body-font-family;
      text-transform: uppercase;
      width: 100%;
      font-size: 9px;
      background: none;
      outline: none;
      border: none;
      padding: 12px 0;
      font-weight: 600;
    }
    .accordion__body {
      padding: 0px 0px 20px;
    }

    .question-text {
      font-size: 10px;
      letter-spacing: 0.55px;
    }
  }
}
</style>
